<template>
  <div class="crop-dialog-container">
    <el-dialog title="logo" width="890px" :visible.sync="dialogVisible" :append-to-body="true" :close-on-click-modal="false" :before-close="handleCancel">
      <div class="crop-container-div">
        <div class="crop-container">
          <div class="crop-area">
            <img id="Logoimage" :src="cropImgUrl" alt="Picture" />
          </div>
          <div class="preview-area">
            <img :src="previewImgUrl" class="preview-img" alt="" />
          </div>
        </div>
        <div class="deal-area">
          <input type="button" class="deal-btn upload-btn" value="上传图像" @click="triggerUpload" />
          <input type="button" class="deal-btn" value="+" @click="zoom(0.1)" />
          <input type="button" class="deal-btn" value="-" @click="zoom(-0.01)" />
          <input type="button" class="deal-btn" value="裁切" @click="cutImage" />
          <input type="button" class="deal-btn" value="取消" @click="handleCancel" />
          <input type="button" class="deal-btn" value="确定" @click="confirm" />
          <input type="file" class="" name="upload-file" id="upload-file" accept="image/png, image/jpeg, image/jpg" @change="uploadImage($event)" style="display:none" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Cropper from 'cropperjs'
import editApi from '@api/setBook'
export default {
  name: 'LogoCropDialog',
  data() {
    return {
      dialogVisible: false,
      showImage: false,
      picName: '',
      ispclogo: false,
      finalFile: null, //上传图像文件
      previewImgUrl: '' // 预览图片地址
    }
  },
  props: {
    cropImgUrl: String,
    imgName: String
  },
  methods: {
    triggerUpload() {
      document.querySelector('#upload-file').click()
    },
    uploadImage(e) {
      var _this = this
      //上传图片
      var file = e.target.files[0]
      _this.picName = file.name
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        return false
      }
      let imgFile = new FileReader()
      imgFile.readAsDataURL(file)
      imgFile.onload = (res) => {
        this.$emit('update:cropImgUrl', res.target.result)
        _this.cropper.destroy()
        _this.$nextTick(() => {
          _this.init()
        })
      }
    },
    init() {
      let image = document.querySelector('#Logoimage')
      this.cropper = new Cropper(image, {
        background: false,
        dragMode: 'move',
        viewMode: 1,
        center: true,
        cropBoxMovable: true, // 是否通过拖拽来移动剪裁框
        cropBoxResizable: true, // 是否通过拖动来调整剪裁框的大小
        ready: () => {
          this.cropper.zoomTo(1)
          this.cropper.setCropBoxData({
            top: 75,
            left: 75,
            width: 240,
            height: 70
          })
        }
      })
    },
    zoom(value, e) {
      this.cropper.zoom(value)
    },
    cutImage() {
      let _this = this
      let croppedCanvas = this.cropper.getCroppedCanvas()
      this.previewImgUrl = croppedCanvas.toDataURL('image/png')
      let name = _this.picName !== '' ? _this.picName : _this.imgName
      croppedCanvas.toBlob((blobObj) => {
        _this.finalFile = new window.File([blobObj], name, { type: 'image/png' })
      })
    },
    confirm() {
      if (!this.previewImgUrl) {
        this.$message.error('请裁剪图片')
        return false
      }
      let _this = this
      let params = new FormData()
      if (this.ispclogo) {
        params.append('fieldName', 'pcLogo')
        params.append('pcLogo', this.finalFile)
      } else {
        params.append('fieldName', 'logo')
        params.append('logo', this.finalFile)
      }
      editApi.uploadPicture(params).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          _this.$emit('update:cropImgUrl', res.data.data)
          _this.$emit('cropConfirm', this.ispclogo)
          _this.cropper.destroy()
          _this.$nextTick(() => {
            _this.init()
          })
        } else {
          console.log('上传背景失败')
        }
      })
      this.handleCancel()
    },
    handleCancel() {
      //  需要先销毁 否则再次打开的时候展示的依然是之前的图片
      this.cropper.destroy()
      this.dialogVisible = false
      this.$emit('update:cropImgUrl', '')
    }
  }
}
</script>
<style lang="scss" scoped>
.crop-container-div {
  .crop-container {
    height: 450px;
    .crop-area {
      width: 450px;
      height: 450px;
      margin-right: 20px;
      float: left;
      border: 1px solid #aaa;
      background: #fff;
      overflow: hidden;
      background-repeat: no-repeat;
      cursor: move;
      box-shadow: 4px 4px 12px #b0b0b0;
    }
    .preview-area {
      width: 320px;
      height: 450px;
      float: left;
      border: 1px #ddd solid;
      padding: 75px 10px;
      box-shadow: 0px 0px 12px #ddd;
      .preview-img {
        width: 300px !important;
        height: 87.5px !important;
        transform: none !important;
      }
    }
  }
  .deal-area {
    margin: 10px 0 27px;
  }
  .deal-btn {
    width: 66px;
    display: inline-block;
    margin-bottom: 10px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #fff;
    margin: 0px 6px;
    background-color: #df5813;
    border-radius: 3px;
    text-decoration: none;
    cursor: pointer;
    box-shadow: 0px 0px 5px #b0b0b0;
    border: 0px #fff solid;
  }
  .upload-btn {
    width: 122px;
    margin-right: 110px;
  }
}
.cropper-container {
  direction: ltr;
  font-size: 0;
  line-height: 0;
  position: relative;
  -ms-touch-action: none;
  touch-action: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.cropper-container img {
  display: block;
  height: 100%;
  image-orientation: 0deg;
  max-height: none !important;
  max-width: none !important;
  min-height: 0 !important;
  min-width: 0 !important;
  width: 100%;
}
.cropper-wrap-box,
.cropper-canvas,
.cropper-drag-box,
.cropper-crop-box,
.cropper-modal {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
.cropper-wrap-box,
.cropper-canvas {
  overflow: hidden;
}
.cropper-drag-box {
  background-color: #fff;
  opacity: 0;
}
.cropper-modal {
  background-color: #000;
  opacity: 0.5;
}
.cropper-view-box {
  display: block;
  height: 100%;
  outline-color: rgba(51, 153, 255, 0.75);
  outline: 1px solid #39f;
  overflow: hidden;
  width: 100%;
}
.cropper-dashed {
  border: 0 dashed #eee;
  display: block;
  opacity: 0.5;
  position: absolute;
}
.cropper-dashed.dashed-h {
  border-bottom-width: 1px;
  border-top-width: 1px;
  height: calc(100% / 3);
  left: 0;
  top: calc(100% / 3);
  width: 100%;
}
.cropper-dashed.dashed-v {
  border-left-width: 1px;
  border-right-width: 1px;
  height: 100%;
  left: calc(100% / 3);
  top: 0;
  width: calc(100% / 3);
}
.cropper-center {
  display: block;
  height: 0;
  left: 50%;
  opacity: 0.75;
  position: absolute;
  top: 50%;
  width: 0;
}
.cropper-center:before,
.cropper-center:after {
  background-color: #eee;
  content: ' ';
  display: block;
  position: absolute;
}
.cropper-center:before {
  height: 1px;
  left: -3px;
  top: 0;
  width: 7px;
}
.cropper-center:after {
  height: 7px;
  left: 0;
  top: -3px;
  width: 1px;
}
.cropper-face,
.cropper-line,
.cropper-point {
  display: block;
  height: 100%;
  opacity: 0.1;
  position: absolute;
  width: 100%;
}
.cropper-face {
  background-color: #fff;
  left: 0;
  top: 0;
}
.cropper-line {
  background-color: #39f;
}
.cropper-line.line-e {
  cursor: ew-resize;
  right: -3px;
  top: 0;
  width: 5px;
}
.cropper-line.line-n {
  cursor: ns-resize;
  height: 5px;
  left: 0;
  top: -3px;
}
.cropper-line.line-w {
  cursor: ew-resize;
  left: -3px;
  top: 0;
  width: 5px;
}
.cropper-line.line-s {
  bottom: -3px;
  cursor: ns-resize;
  height: 5px;
  left: 0;
}
.cropper-point {
  background-color: #39f;
  height: 5px;
  opacity: 0.75;
  width: 5px;
}
.cropper-point.point-e {
  cursor: ew-resize;
  margin-top: -3px;
  right: -3px;
  top: 50%;
}
.cropper-point.point-n {
  cursor: ns-resize;
  left: 50%;
  margin-left: -3px;
  top: -3px;
}
.cropper-point.point-w {
  cursor: ew-resize;
  left: -3px;
  margin-top: -3px;
  top: 50%;
}
.cropper-point.point-s {
  bottom: -3px;
  cursor: s-resize;
  left: 50%;
  margin-left: -3px;
}
.cropper-point.point-ne {
  cursor: nesw-resize;
  right: -3px;
  top: -3px;
}
.cropper-point.point-nw {
  cursor: nwse-resize;
  left: -3px;
  top: -3px;
}
.cropper-point.point-sw {
  bottom: -3px;
  cursor: nesw-resize;
  left: -3px;
}
.cropper-point.point-se {
  bottom: -3px;
  cursor: nwse-resize;
  height: 20px;
  opacity: 1;
  right: -3px;
  width: 20px;
}
@media (min-width: 768px) {
  .cropper-point.point-se {
    height: 15px;
    width: 15px;
  }
}
@media (min-width: 992px) {
  .cropper-point.point-se {
    height: 10px;
    width: 10px;
  }
}
@media (min-width: 1200px) {
  .cropper-point.point-se {
    height: 5px;
    opacity: 0.75;
    width: 5px;
  }
}
.cropper-point.point-se:before {
  background-color: #39f;
  bottom: -50%;
  content: ' ';
  display: block;
  height: 200%;
  opacity: 0;
  position: absolute;
  right: -50%;
  width: 200%;
}
.cropper-invisible {
  opacity: 0;
}
.cropper-bg {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');
}
.cropper-hide {
  display: block;
  height: 0;
  position: absolute;
  width: 0;
}
.cropper-hidden {
  display: none !important;
}
.cropper-move {
  cursor: move;
}
.cropper-crop {
  cursor: crosshair;
}
.cropper-disabled .cropper-drag-box,
.cropper-disabled .cropper-face,
.cropper-disabled .cropper-line,
.cropper-disabled .cropper-point {
  cursor: not-allowed;
}
</style>
